import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage.tsx'
import { EveningMessagesPage } from '@/pages/messages/EveningMessagesPage'
import { eveningTeamsQuery } from '@/state/regions/regions'
import { teamMessagesQuery } from '@/state/teamMessages/teamMessages'

const eveningMessagesSearchSchema = z.object({
  regionName: z.string().optional(),
  piloteRegionId: z.number().optional(),
  eveningDate: z.string().optional(),
  regionId: z.string().optional(),
})

export const Route = createFileRoute('/regions/messages/$eveningId/$teamId')({
  validateSearch: eveningMessagesSearchSchema,
  component: withErrorBoundary(EveningMessagesPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.fetchQuery(teamMessagesQuery(params.teamId)),
      context.queryClient.fetchQuery(eveningTeamsQuery(Number(params.eveningId))),
    ])
  },
  gcTime: 5000,
  wrapInSuspense: true,
})
